module.exports = __webpack_public_path__ + "static/media/img_404.40319245.svg";